export const isProdEnv = process.env.GATSBY_ENV === 'prod'

export const noIndex = metaValue =>
  metaValue === 'noindex' || !isProdEnv ? 'noindex' : 'index'
export const noFollow = metaValue =>
  metaValue === 'nofollow' || !isProdEnv ? 'nofollow' : 'follow'
